import Phaser from 'phaser';
import { loadGame, clearSave, hasSave } from '../systems/SaveState';
import { loadDailyGame, clearDailySave, hasDailySave } from '../systems/DailySave';

export class BootScene extends Phaser.Scene {
  constructor() {
    super('BootScene');
  }

  create(): void {
    const dailySave = hasDailySave() ? loadDailyGame() : null;
    const campaignSave = hasSave() ? loadGame() : null;

    if (dailySave && campaignSave) {
      const dailyTime = dailySave.lastPlayed ?? 0;
      const campaignTime = campaignSave.lastPlayed ?? 0;

      if (dailyTime >= campaignTime) {
        this.scene.start('GameScene', { dailySaveData: dailySave });
      } else {
        this.scene.start('GameScene', { saveData: campaignSave });
      }
      return;
    }

    if (dailySave) {
      this.scene.start('GameScene', { dailySaveData: dailySave });
      return;
    }

    if (campaignSave) {
      this.scene.start('GameScene', { saveData: campaignSave });
      return;
    }

    if (hasSave()) clearSave();
    if (hasDailySave()) clearDailySave();

    this.scene.start('TitleScene');
  }
}
